import React from 'react'
import PropTypes from 'prop-types'

import FieldBase from 'components/atoms/FieldBase'
import ImageUpload from 'components/organisms/ImageUpload'

const ImageUploadField = ({...other}) => (
  <FieldBase component={ImageUpload} {...other} />
)

ImageUploadField.displayName = 'ImageUploadField'

ImageUploadField.propTypes = {
  name: PropTypes.string.isRequired
}

export default ImageUploadField



// WEBPACK FOOTER //
// ./src/components/organisms/ImageUpload/ImageUploadField.js